module.exports = __webpack_public_path__ + "img/plan.d7d1b64f.png";